import { NodeViewWrapper } from '@tiptap/react';
import React from 'react';
import cn from 'classnames';
import { getExternalRenderer, getPresetId } from '../../../components/utils/tiptap';
import { useSize } from '../hooks/useSize';
import { useEditorContainerSize } from '../../../components/Editor/Context';
import { EXTENSION_TYPE_NAME } from '../constants';
import viewerStyles from '../Viewer/Viewer.scss';
const DeviationThumbNodeView = (props)=>{
    const Renderer = props.editor.extensionStorage['da-ext-renderers'].inline;
    const { editor, extension, node } = props;
    const { options } = extension;
    const attrs = node.attrs;
    const containerSize = useEditorContainerSize();
    const deviationMediaService = getExternalRenderer(editor, 'mediaService');
    const { width, height } = useSize(deviationMediaService, attrs, options, containerSize !== null && containerSize !== void 0 ? containerSize : Infinity);
    const nodeKey = `img-${!attrs.width ? 'default' : 'custom'}`;
    return /*#__PURE__*/ React.createElement(NodeViewWrapper, {
        key: nodeKey,
        "data-drag-handle": "true",
        className: cn('draggable-atomic', viewerStyles['outer-span'], viewerStyles[`preset-${getPresetId(editor)}`]),
        as: 'span',
        "data-deviation": JSON.stringify(attrs.deviation),
        "data-width": attrs.width,
        "data-height": attrs.height,
        "data-cropping": attrs.cropping,
        "data-link": attrs.link,
        "data-aspect": attrs.aspect,
        "data-da-type": EXTENSION_TYPE_NAME
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            pointerEvents: 'none'
        }
    }, /*#__PURE__*/ React.createElement(Renderer, {
        deviation: attrs.deviation,
        width: width,
        height: height,
        crop: attrs.cropping,
        link: attrs.link,
        inEditor: true,
        extOptions: options
    })));
};
DeviationThumbNodeView.displayName = 'DeviationNodeView';
export default DeviationThumbNodeView;

//# sourceMappingURL=DeviationThumbNodeView.js.map